import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from '@mui/material'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData, TMemberRole } from 'types/final-protocol'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const CommissionMembersTable = ({ protocolData }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields } = useFieldArray({
    control,
    name: `commissionMembers`,
  })

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('ordinal')}</TableCell>
            <TableCell>{t('name-surname-father-name')}</TableCell>
            <TableCell>{t('work-job-position')}</TableCell>
            <TableCell>{t('role-in-commission')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((member, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionMembers.${index}.fullName`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionMembers.${index}.workPlaceAndPosition`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionMembers.${index}.memberRole`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        value={
                          field.value === TMemberRole.CHAIRMAN ||
                          field.value === TMemberRole.ORDINARY
                            ? t(`${field.value}`)
                            : field.value
                        }
                        variant="outlined"
                      />
                    )}
                  />
                </StyledTableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
